import { DashboardLayout } from '../components/layout/DashboardLayout';
import { useEffect, useState } from 'react';
import axios from 'axios';
import { BookOpen, Plus, Trash2, Edit2, Search, Sparkles, CheckSquare, Square, ChevronDown, ChevronUp, X } from 'lucide-react';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
const JENJANG_LIST = ['SD', 'SMP', 'SMA', 'SMK'];
const JENJANG_KELAS = { SD: [1,2,3,4,5,6], SMP: [7,8,9], SMA: [10,11,12], SMK: [10,11,12] };
const EMPTY_FORM = { name: '', jenjang: 'SMP', kelas: [7, 8, 9] };

// ── Katalog resmi Permendikdasmen No. 13 Tahun 2025 ──────────────────────────
// Format: { name, kelas: [array kelas yang berlaku], wajib: bool, kategori }
const KATALOG_REGULASI = {
  SD: [
    // Wajib semua kelas
    { name: 'Pendidikan Agama Islam dan Budi Pekerti',     kelas: [1,2,3,4,5,6], wajib: true,  kategori: 'Wajib' },
    { name: 'Pendidikan Agama Kristen dan Budi Pekerti',   kelas: [1,2,3,4,5,6], wajib: true,  kategori: 'Wajib' },
    { name: 'Pendidikan Agama Katolik dan Budi Pekerti',   kelas: [1,2,3,4,5,6], wajib: true,  kategori: 'Wajib' },
    { name: 'Pendidikan Agama Buddha dan Budi Pekerti',    kelas: [1,2,3,4,5,6], wajib: true,  kategori: 'Wajib' },
    { name: 'Pendidikan Agama Hindu dan Budi Pekerti',     kelas: [1,2,3,4,5,6], wajib: true,  kategori: 'Wajib' },
    { name: 'Pendidikan Agama Khonghucu dan Budi Pekerti', kelas: [1,2,3,4,5,6], wajib: true,  kategori: 'Wajib' },
    { name: 'Pendidikan Pancasila',                        kelas: [1,2,3,4,5,6], wajib: true,  kategori: 'Wajib' },
    { name: 'Bahasa Indonesia',                            kelas: [1,2,3,4,5,6], wajib: true,  kategori: 'Wajib' },
    { name: 'Matematika',                                  kelas: [1,2,3,4,5,6], wajib: true,  kategori: 'Wajib' },
    { name: 'Ilmu Pengetahuan Alam dan Sosial',            kelas: [3,4,5,6],     wajib: true,  kategori: 'Wajib' },
    { name: 'Pendidikan Jasmani Olahraga dan Kesehatan',   kelas: [1,2,3,4,5,6], wajib: true,  kategori: 'Wajib' },
    { name: 'Seni Musik',                                  kelas: [1,2,3,4,5,6], wajib: true,  kategori: 'Seni & Budaya' },
    { name: 'Seni Rupa',                                   kelas: [1,2,3,4,5,6], wajib: true,  kategori: 'Seni & Budaya' },
    { name: 'Seni Teater',                                 kelas: [1,2,3,4,5,6], wajib: true,  kategori: 'Seni & Budaya' },
    { name: 'Seni Tari',                                   kelas: [1,2,3,4,5,6], wajib: true,  kategori: 'Seni & Budaya' },
    { name: 'Bahasa Inggris',                              kelas: [3,4,5,6],     wajib: true,  kategori: 'Wajib' },
    { name: 'Muatan Lokal',                                kelas: [1,2,3,4,5,6], wajib: false, kategori: 'Muatan Lokal' },
    { name: 'Koding dan Kecerdasan Artifisial',            kelas: [5,6],         wajib: false, kategori: 'Pilihan' },
  ],
  SMP: [
    // Kelas 7–8
    { name: 'Pendidikan Agama Islam dan Budi Pekerti',     kelas: [7,8,9], wajib: true,  kategori: 'Wajib' },
    { name: 'Pendidikan Agama Kristen dan Budi Pekerti',   kelas: [7,8,9], wajib: true,  kategori: 'Wajib' },
    { name: 'Pendidikan Agama Katolik dan Budi Pekerti',   kelas: [7,8,9], wajib: true,  kategori: 'Wajib' },
    { name: 'Pendidikan Agama Buddha dan Budi Pekerti',    kelas: [7,8,9], wajib: true,  kategori: 'Wajib' },
    { name: 'Pendidikan Agama Hindu dan Budi Pekerti',     kelas: [7,8,9], wajib: true,  kategori: 'Wajib' },
    { name: 'Pendidikan Agama Khonghucu dan Budi Pekerti', kelas: [7,8,9], wajib: true,  kategori: 'Wajib' },
    { name: 'Pendidikan Pancasila',                        kelas: [7,8,9], wajib: true,  kategori: 'Wajib' },
    { name: 'Bahasa Indonesia',                            kelas: [7,8,9], wajib: true,  kategori: 'Wajib' },
    { name: 'Matematika',                                  kelas: [7,8,9], wajib: true,  kategori: 'Wajib' },
    { name: 'Ilmu Pengetahuan Alam',                       kelas: [7,8,9], wajib: true,  kategori: 'Wajib' },
    { name: 'Ilmu Pengetahuan Sosial',                     kelas: [7,8,9], wajib: true,  kategori: 'Wajib' },
    { name: 'Bahasa Inggris',                              kelas: [7,8,9], wajib: true,  kategori: 'Wajib' },
    { name: 'Pendidikan Jasmani Olahraga dan Kesehatan',   kelas: [7,8,9], wajib: true,  kategori: 'Wajib' },
    { name: 'Informatika',                                 kelas: [7,8,9], wajib: true,  kategori: 'Wajib' },
    { name: 'Seni Musik',                                  kelas: [7,8,9], wajib: true,  kategori: 'Seni, Budaya & Prakarya' },
    { name: 'Seni Rupa',                                   kelas: [7,8,9], wajib: true,  kategori: 'Seni, Budaya & Prakarya' },
    { name: 'Seni Teater',                                 kelas: [7,8,9], wajib: true,  kategori: 'Seni, Budaya & Prakarya' },
    { name: 'Seni Tari',                                   kelas: [7,8,9], wajib: true,  kategori: 'Seni, Budaya & Prakarya' },
    { name: 'Prakarya Budi Daya',                          kelas: [7,8,9], wajib: true,  kategori: 'Seni, Budaya & Prakarya' },
    { name: 'Prakarya Kerajinan',                          kelas: [7,8,9], wajib: true,  kategori: 'Seni, Budaya & Prakarya' },
    { name: 'Prakarya Rekayasa',                           kelas: [7,8,9], wajib: true,  kategori: 'Seni, Budaya & Prakarya' },
    { name: 'Prakarya Pengolahan',                         kelas: [7,8,9], wajib: true,  kategori: 'Seni, Budaya & Prakarya' },
    { name: 'Koding dan Kecerdasan Artifisial',            kelas: [7,8,9], wajib: false, kategori: 'Pilihan' },
    { name: 'Muatan Lokal',                                kelas: [7,8,9], wajib: false, kategori: 'Muatan Lokal' },
  ],
  SMA: [
    // Kelas X — Mata Pelajaran Wajib
    { name: 'Pendidikan Agama Islam dan Budi Pekerti',     kelas: [10,11,12], wajib: true,  kategori: 'Wajib' },
    { name: 'Pendidikan Agama Kristen dan Budi Pekerti',   kelas: [10,11,12], wajib: true,  kategori: 'Wajib' },
    { name: 'Pendidikan Agama Katolik dan Budi Pekerti',   kelas: [10,11,12], wajib: true,  kategori: 'Wajib' },
    { name: 'Pendidikan Agama Buddha dan Budi Pekerti',    kelas: [10,11,12], wajib: true,  kategori: 'Wajib' },
    { name: 'Pendidikan Agama Hindu dan Budi Pekerti',     kelas: [10,11,12], wajib: true,  kategori: 'Wajib' },
    { name: 'Pendidikan Agama Khonghucu dan Budi Pekerti', kelas: [10,11,12], wajib: true,  kategori: 'Wajib' },
    { name: 'Pendidikan Pancasila',                        kelas: [10,11,12], wajib: true,  kategori: 'Wajib' },
    { name: 'Bahasa Indonesia',                            kelas: [10,11,12], wajib: true,  kategori: 'Wajib' },
    { name: 'Matematika',                                  kelas: [10,11,12], wajib: true,  kategori: 'Wajib' },
    { name: 'Bahasa Inggris',                              kelas: [10,11,12], wajib: true,  kategori: 'Wajib' },
    { name: 'Pendidikan Jasmani Olahraga dan Kesehatan',   kelas: [10,11,12], wajib: true,  kategori: 'Wajib' },
    { name: 'Sejarah',                                     kelas: [11,12],    wajib: true,  kategori: 'Wajib' },
    { name: 'Seni dan Budaya',                             kelas: [10,11,12], wajib: true,  kategori: 'Wajib' },
    { name: 'Informatika',                                 kelas: [10],       wajib: true,  kategori: 'Wajib' },
    // Kelas X — Ilmu Alam & Sosial (tidak dipisah di kelas X)
    { name: 'Ilmu Pengetahuan Alam (Fisika, Kimia, Biologi)', kelas: [10],   wajib: true,  kategori: 'Ilmu Pengetahuan' },
    { name: 'Ilmu Pengetahuan Sosial (Sosiologi, Ekonomi, Sejarah, Geografi)', kelas: [10], wajib: true, kategori: 'Ilmu Pengetahuan' },
    // Pilihan Kelas XI-XII
    { name: 'Matematika Tingkat Lanjut',   kelas: [11,12], wajib: false, kategori: 'Pilihan Peminatan' },
    { name: 'Fisika',                      kelas: [11,12], wajib: false, kategori: 'Pilihan Peminatan' },
    { name: 'Kimia',                       kelas: [11,12], wajib: false, kategori: 'Pilihan Peminatan' },
    { name: 'Biologi',                     kelas: [11,12], wajib: false, kategori: 'Pilihan Peminatan' },
    { name: 'Geografi',                    kelas: [11,12], wajib: false, kategori: 'Pilihan Peminatan' },
    { name: 'Sejarah Tingkat Lanjut',      kelas: [11,12], wajib: false, kategori: 'Pilihan Peminatan' },
    { name: 'Sosiologi',                   kelas: [11,12], wajib: false, kategori: 'Pilihan Peminatan' },
    { name: 'Ekonomi',                     kelas: [11,12], wajib: false, kategori: 'Pilihan Peminatan' },
    { name: 'Bahasa Indonesia Tingkat Lanjut', kelas: [11,12], wajib: false, kategori: 'Pilihan Peminatan' },
    { name: 'Bahasa Inggris Tingkat Lanjut',   kelas: [11,12], wajib: false, kategori: 'Pilihan Peminatan' },
    { name: 'Bahasa Arab',                 kelas: [11,12], wajib: false, kategori: 'Pilihan Peminatan' },
    { name: 'Bahasa Jepang',               kelas: [11,12], wajib: false, kategori: 'Pilihan Peminatan' },
    { name: 'Bahasa Mandarin',             kelas: [11,12], wajib: false, kategori: 'Pilihan Peminatan' },
    { name: 'Anthropologi',                kelas: [11,12], wajib: false, kategori: 'Pilihan Peminatan' },
    { name: 'Informatika',                 kelas: [11,12], wajib: false, kategori: 'Pilihan Peminatan' },
    { name: 'Koding dan Kecerdasan Artifisial', kelas: [10,11,12], wajib: false, kategori: 'Pilihan' },
    { name: 'Prakarya dan Kewirausahaan',  kelas: [11,12], wajib: false, kategori: 'Pilihan' },
    { name: 'Muatan Lokal',                kelas: [10,11,12], wajib: false, kategori: 'Muatan Lokal' },
  ],
  SMK: [
    // Mata Pelajaran Umum
    { name: 'Pendidikan Agama Islam dan Budi Pekerti',     kelas: [10,11,12], wajib: true, kategori: 'Umum' },
    { name: 'Pendidikan Agama Kristen dan Budi Pekerti',   kelas: [10,11,12], wajib: true, kategori: 'Umum' },
    { name: 'Pendidikan Agama Katolik dan Budi Pekerti',   kelas: [10,11,12], wajib: true, kategori: 'Umum' },
    { name: 'Pendidikan Agama Buddha dan Budi Pekerti',    kelas: [10,11,12], wajib: true, kategori: 'Umum' },
    { name: 'Pendidikan Agama Hindu dan Budi Pekerti',     kelas: [10,11,12], wajib: true, kategori: 'Umum' },
    { name: 'Pendidikan Agama Khonghucu dan Budi Pekerti', kelas: [10,11,12], wajib: true, kategori: 'Umum' },
    { name: 'Pendidikan Pancasila',                        kelas: [10,11,12], wajib: true, kategori: 'Umum' },
    { name: 'Bahasa Indonesia',                            kelas: [10,11,12], wajib: true, kategori: 'Umum' },
    { name: 'Pendidikan Jasmani Olahraga dan Kesehatan',   kelas: [10,11,12], wajib: true, kategori: 'Umum' },
    { name: 'Sejarah',                                     kelas: [10,11,12], wajib: true, kategori: 'Umum' },
    { name: 'Seni dan Budaya',                             kelas: [10],       wajib: true, kategori: 'Umum' },
    // Mata Pelajaran Kejuruan
    { name: 'Matematika',                                  kelas: [10,11,12], wajib: true, kategori: 'Kejuruan' },
    { name: 'Bahasa Inggris',                              kelas: [10,11,12], wajib: true, kategori: 'Kejuruan' },
    { name: 'Informatika',                                 kelas: [10],       wajib: true, kategori: 'Kejuruan' },
    { name: 'Projek Ilmu Pengetahuan Alam dan Sosial',     kelas: [10],       wajib: true, kategori: 'Kejuruan' },
    { name: 'Dasar-Dasar Program Keahlian',                kelas: [10],       wajib: true, kategori: 'Kejuruan' },
    { name: 'Konsentrasi Keahlian',                        kelas: [11,12],    wajib: true, kategori: 'Kejuruan' },
    { name: 'Kreativitas, Inovasi, dan Kewirausahaan',     kelas: [11,12],    wajib: true, kategori: 'Kejuruan' },
    { name: 'Praktik Kerja Lapangan (PKL)',                kelas: [12],       wajib: true, kategori: 'Kejuruan' },
    { name: 'Koding dan Kecerdasan Artifisial',            kelas: [10,11,12], wajib: false, kategori: 'Pilihan' },
    { name: 'Muatan Lokal',                                kelas: [10,11,12], wajib: false, kategori: 'Muatan Lokal' },
  ],
};

const KATEGORI_COLOR = {
  'Wajib':               'bg-blue-100 text-blue-700',
  'Seni & Budaya':       'bg-purple-100 text-purple-700',
  'Seni, Budaya & Prakarya': 'bg-purple-100 text-purple-700',
  'Ilmu Pengetahuan':    'bg-cyan-100 text-cyan-700',
  'Pilihan Peminatan':   'bg-amber-100 text-amber-700',
  'Pilihan':             'bg-orange-100 text-orange-700',
  'Umum':                'bg-blue-100 text-blue-700',
  'Kejuruan':            'bg-green-100 text-green-700',
  'Muatan Lokal':        'bg-slate-100 text-slate-600',
};

export const AdminSubjects = () => {
  const [subjects, setSubjects] = useState([]);
  const [loading, setLoading] = useState(true);
  const [search, setSearch] = useState('');
  const [filterJenjang, setFilterJenjang] = useState('');
  const [modal, setModal] = useState(null); // null | 'add' | 'regulasi' | subject_obj
  const [form, setForm] = useState(EMPTY_FORM);
  const [saving, setSaving] = useState(false);

  // State untuk modal regulasi
  const [regJenjang, setRegJenjang] = useState('SMP');
  const [regKelas, setRegKelas] = useState(7);
  const [regSelected, setRegSelected] = useState(new Set());
  const [regExpanded, setRegExpanded] = useState({});
  const [regSaving, setRegSaving] = useState(false);

  useEffect(() => { loadSubjects(); }, []);

  const loadSubjects = async () => {
    setLoading(true);
    try {
      const { data } = await axios.get(`${API}/subjects`, { withCredentials: true });
      setSubjects(data);
    } catch (e) {
      console.error(e);
    } finally {
      setLoading(false);
    }
  };

  const openAdd = () => { setForm(EMPTY_FORM); setModal('add'); };
  const openEdit = (s) => {
    const kelas = Array.isArray(s.kelas) ? s.kelas.map(Number) : [Number(s.kelas)];
    setForm({ name: s.name, jenjang: s.jenjang, kelas });
    setModal(s);
  };

  const openRegulasiModal = () => {
    setRegJenjang('SMP');
    setRegKelas(7);
    setRegSelected(new Set());
    setRegExpanded({});
    setModal('regulasi');
  };

  const handleSave = async () => {
    if (!form.name.trim()) return alert('Nama mata pelajaran wajib diisi');
    if (!form.kelas || (Array.isArray(form.kelas) && form.kelas.length === 0)) return alert('Pilih minimal 1 kelas');
    setSaving(true);
    try {
      if (modal === 'add') {
        await axios.post(`${API}/subjects`, form, { withCredentials: true });
      } else {
        await axios.put(`${API}/subjects/${modal._id}`, form, { withCredentials: true });
      }
      await loadSubjects();
      setModal(null);
    } catch (e) {
      alert(e.response?.data?.detail || 'Gagal menyimpan');
    } finally {
      setSaving(false);
    }
  };

  const handleDelete = async (id, name) => {
    if (!window.confirm(`Hapus mata pelajaran "${name}"?`)) return;
    try {
      await axios.delete(`${API}/subjects/${id}`, { withCredentials: true });
      await loadSubjects();
    } catch (e) {
      alert(e.response?.data?.detail || 'Gagal menghapus');
    }
  };

  // Hitung mapel dari katalog yang belum ada di DB untuk jenjang+kelas terpilih
  const getAvailableFromKatalog = () => {
    const kelasNum = parseInt(regKelas, 10);
    const existing = new Set(
      subjects
        .filter(s => {
          if (s.jenjang !== regJenjang) return false;
          // kelas bisa array of numbers atau string/number tunggal
          if (Array.isArray(s.kelas)) return s.kelas.map(Number).includes(kelasNum);
          return String(s.kelas) === String(regKelas);
        })
        .map(s => s.name)
    );
    return (KATALOG_REGULASI[regJenjang] || []).filter(
      item => item.kelas.includes(regKelas) && !existing.has(item.name)
    );
  };

  // Group available items by kategori
  const getGroupedAvailable = () => {
    const items = getAvailableFromKatalog();
    const groups = {};
    items.forEach(item => {
      if (!groups[item.kategori]) groups[item.kategori] = [];
      groups[item.kategori].push(item);
    });
    return groups;
  };

  const toggleRegItem = (name) => {
    setRegSelected(prev => {
      const next = new Set(prev);
      if (next.has(name)) next.delete(name);
      else next.add(name);
      return next;
    });
  };

  const toggleKategori = (kategori, items) => {
    const allSelected = items.every(i => regSelected.has(i.name));
    setRegSelected(prev => {
      const next = new Set(prev);
      if (allSelected) items.forEach(i => next.delete(i.name));
      else items.forEach(i => next.add(i.name));
      return next;
    });
  };

  const selectAllAvailable = () => {
    const items = getAvailableFromKatalog();
    setRegSelected(new Set(items.map(i => i.name)));
  };

  const handleSaveFromRegulasiModal = async () => {
    if (regSelected.size === 0) return alert('Pilih minimal 1 mata pelajaran');
    setRegSaving(true);
    try {
      const items = getAvailableFromKatalog().filter(i => regSelected.has(i.name));
      await Promise.all(
        items.map(item =>
          axios.post(`${API}/subjects`, { name: item.name, jenjang: regJenjang, kelas: item.kelas }, { withCredentials: true })
        )
      );
      await loadSubjects();
      setModal(null);
    } catch (e) {
      const detail = e.response?.data?.detail;
      const msg = typeof detail === 'string' ? detail : detail ? JSON.stringify(detail) : e.message || 'Gagal menyimpan';
      alert(msg);
    } finally {
      setRegSaving(false);
    }
  };

  const filtered = subjects.filter(s =>
    (!filterJenjang || s.jenjang === filterJenjang) &&
    s.name.toLowerCase().includes(search.toLowerCase())
  );

  const grouped = JENJANG_LIST.reduce((acc, j) => {
    acc[j] = filtered.filter(s => s.jenjang === j);
    return acc;
  }, {});

  const availableItems = getAvailableFromKatalog();
  const groupedAvailable = getGroupedAvailable();

  return (
    <DashboardLayout>
      <div className="max-w-5xl mx-auto" style={{ fontFamily: "'IBM Plex Sans', sans-serif" }}>

        {/* Header */}
        <div className="flex flex-col sm:flex-row sm:items-center justify-between gap-4 mb-8">
          <div>
            <h1 className="text-3xl font-bold text-blue-900" style={{ fontFamily: "'Outfit', sans-serif" }}>
              Mata Pelajaran
            </h1>
            <p className="text-slate-500 text-sm mt-1">{subjects.length} mata pelajaran tersedia</p>
          </div>
          <div className="flex gap-3">
            <button onClick={openRegulasiModal}
              className="inline-flex items-center gap-2 px-4 py-2.5 rounded-xl font-semibold text-sm border-2 border-blue-200 text-blue-700 hover:bg-blue-50 transition-all">
              <Sparkles size={16} /> Dari Regulasi
            </button>
            <button onClick={openAdd}
              className="inline-flex items-center gap-2 px-5 py-2.5 rounded-xl text-white font-semibold text-sm shadow-md hover:shadow-lg hover:-translate-y-0.5 transition-all"
              style={{ background: 'linear-gradient(135deg, #1E3A8A, #3B82F6)' }}>
              <Plus size={16} /> Tambah Manual
            </button>
          </div>
        </div>

        {/* Banner info regulasi */}
        <div className="mb-6 flex items-center gap-3 px-4 py-3 rounded-xl bg-green-50 border border-green-200">
          <div className="w-8 h-8 rounded-lg bg-green-100 flex items-center justify-center flex-shrink-0">
            <Sparkles size={16} className="text-green-600" />
          </div>
          <div>
            <div className="text-xs font-bold text-green-800">Berdasarkan Permendikdasmen No. 13 Tahun 2025</div>
            <div className="text-xs text-green-600">Klik "Dari Regulasi" untuk menambahkan mata pelajaran resmi sesuai jenjang & kelas secara cepat.</div>
          </div>
        </div>

        {/* Filter & Search */}
        <div className="flex flex-wrap gap-3 mb-6">
          <div className="relative flex-1 min-w-48">
            <Search size={15} className="absolute left-3.5 top-1/2 -translate-y-1/2 text-slate-400" />
            <input
              type="text"
              placeholder="Cari nama mata pelajaran..."
              value={search}
              onChange={e => setSearch(e.target.value)}
              className="w-full pl-10 pr-4 py-2.5 rounded-xl border border-slate-200 bg-white text-sm focus:outline-none focus:ring-2 focus:ring-blue-200"
            />
          </div>
          <div className="flex gap-2">
            {['', ...JENJANG_LIST].map(j => (
              <button key={j} onClick={() => setFilterJenjang(j)}
                className={`px-4 py-2 rounded-xl text-sm font-semibold transition-all ${
                  filterJenjang === j
                    ? 'text-white shadow-md'
                    : 'bg-white border border-slate-200 text-slate-600 hover:border-blue-200'
                }`}
                style={filterJenjang === j ? { background: 'linear-gradient(135deg, #1E3A8A, #3B82F6)' } : {}}>
                {j || 'Semua'}
              </button>
            ))}
          </div>
        </div>

        {loading ? (
          <div className="flex items-center justify-center py-20">
            <div className="w-8 h-8 rounded-full border-4 border-blue-200 border-t-blue-600 animate-spin" />
          </div>
        ) : (
          <div className="flex flex-col gap-6">
            {JENJANG_LIST.map(j => {
              if (filterJenjang && filterJenjang !== j) return null;
              const items = grouped[j];
              if (items.length === 0 && filterJenjang) return null;
              return (
                <div key={j} className="bg-white border border-slate-100 rounded-2xl shadow-sm overflow-hidden">
                  <div className="flex items-center justify-between px-5 py-3.5 border-b border-slate-100 bg-slate-50">
                    <div className="flex items-center gap-2">
                      <span className="w-6 h-6 rounded-lg flex items-center justify-center text-xs font-bold text-white"
                        style={{ background: 'linear-gradient(135deg, #1E3A8A, #3B82F6)' }}>{j[0]}</span>
                      <span className="font-bold text-slate-700" style={{ fontFamily: "'Outfit', sans-serif" }}>{j}</span>
                      <span className="text-xs text-slate-400">({items.length} mapel)</span>
                    </div>
                  </div>
                  {items.length === 0 ? (
                    <div className="text-center py-8 text-slate-400 text-sm">
                      Belum ada mata pelajaran untuk {j} —{' '}
                      <button onClick={openRegulasiModal} className="text-blue-500 font-semibold hover:underline">
                        Tambah dari regulasi
                      </button>
                    </div>
                  ) : (
                    <div className="divide-y divide-slate-50">
                      {items.map(s => (
                        <div key={s._id} className="flex items-center justify-between px-5 py-3 hover:bg-slate-50 transition-colors">
                          <div className="flex items-center gap-3">
                            <BookOpen size={15} className="text-blue-400 flex-shrink-0" />
                            <div className="flex items-center gap-2 flex-wrap">
                              <span className="font-semibold text-slate-800 text-sm">{s.name}</span>
                              <span className="text-xs text-slate-400 bg-slate-100 px-2 py-0.5 rounded-full">Kelas {s.kelas}</span>
                            </div>
                          </div>
                          <div className="flex items-center gap-2">
                            <button onClick={() => openEdit(s)}
                              className="p-1.5 rounded-lg text-slate-400 hover:text-blue-600 hover:bg-blue-50 transition-colors">
                              <Edit2 size={14} />
                            </button>
                            <button onClick={() => handleDelete(s._id, s.name)}
                              className="p-1.5 rounded-lg text-slate-400 hover:text-red-600 hover:bg-red-50 transition-colors">
                              <Trash2 size={14} />
                            </button>
                          </div>
                        </div>
                      ))}
                    </div>
                  )}
                </div>
              );
            })}
          </div>
        )}
      </div>

      {/* ── Modal Tambah Manual / Edit ──────────────────────────────── */}
      {modal && modal !== 'regulasi' && (
        <div className="fixed inset-0 z-50 flex items-center justify-center p-4"
          style={{ background: 'rgba(15,23,42,0.6)', backdropFilter: 'blur(4px)' }}
          onClick={e => e.target === e.currentTarget && setModal(null)}>
          <div className="bg-white rounded-2xl shadow-2xl w-full max-w-sm p-6">
            <h3 className="font-bold text-slate-800 text-lg mb-5" style={{ fontFamily: "'Outfit', sans-serif" }}>
              {modal === 'add' ? 'Tambah Mata Pelajaran' : 'Edit Mata Pelajaran'}
            </h3>

            <div className="flex flex-col gap-4">
              <div>
                <label className="text-sm font-semibold text-slate-700 block mb-1.5">Nama Mata Pelajaran</label>
                <input
                  type="text"
                  value={form.name}
                  onChange={e => setForm({ ...form, name: e.target.value })}
                  placeholder="Contoh: Matematika"
                  className="w-full border border-slate-200 rounded-xl px-4 py-2.5 text-sm focus:outline-none focus:ring-2 focus:ring-blue-200"
                  autoFocus
                />
              </div>
              <div className="flex flex-col gap-3">
                <div>
                  <label className="text-sm font-semibold text-slate-700 block mb-1.5">Jenjang</label>
                  <select
                    value={form.jenjang}
                    onChange={e => setForm({ ...form, jenjang: e.target.value, kelas: JENJANG_KELAS[e.target.value] })}
                    className="w-full border border-slate-200 rounded-xl px-3 py-2.5 text-sm focus:outline-none focus:ring-2 focus:ring-blue-200 bg-white">
                    {JENJANG_LIST.map(j => <option key={j} value={j}>{j}</option>)}
                  </select>
                </div>
                <div>
                  <div className="flex items-center justify-between mb-1.5">
                    <label className="text-sm font-semibold text-slate-700">Kelas</label>
                    <button
                      type="button"
                      onClick={() => {
                        const all = JENJANG_KELAS[form.jenjang];
                        setForm({ ...form, kelas: form.kelas.length === all.length ? [] : all });
                      }}
                      className="text-xs text-blue-600 font-semibold hover:text-blue-800">
                      {form.kelas.length === JENJANG_KELAS[form.jenjang].length ? 'Batal Semua' : 'Pilih Semua'}
                    </button>
                  </div>
                  <div className="flex flex-wrap gap-2">
                    {(JENJANG_KELAS[form.jenjang] || []).map(k => {
                      const checked = Array.isArray(form.kelas) ? form.kelas.includes(k) : form.kelas === k;
                      return (
                        <label key={k} className={`flex items-center gap-1.5 px-3 py-1.5 rounded-lg border text-sm cursor-pointer transition-all ${
                          checked ? 'border-blue-500 bg-blue-50 text-blue-700 font-semibold' : 'border-slate-200 text-slate-500 hover:border-slate-300'
                        }`}>
                          <input
                            type="checkbox"
                            className="hidden"
                            checked={checked}
                            onChange={() => {
                              const cur = Array.isArray(form.kelas) ? form.kelas : [form.kelas];
                              setForm({ ...form, kelas: checked ? cur.filter(x => x !== k) : [...cur, k].sort((a,b) => a-b) });
                            }}
                          />
                          Kelas {k}
                        </label>
                      );
                    })}
                  </div>
                  {Array.isArray(form.kelas) && form.kelas.length === 0 && (
                    <p className="text-xs text-red-500 mt-1">Pilih minimal 1 kelas</p>
                  )}
                </div>
              </div>
            </div>

            <div className="flex gap-3 mt-6">
              <button onClick={() => setModal(null)}
                className="flex-1 py-2.5 rounded-xl border border-slate-200 text-slate-600 text-sm font-semibold hover:bg-slate-50 transition-colors">
                Batal
              </button>
              <button onClick={handleSave} disabled={saving}
                className="flex-1 py-2.5 rounded-xl text-white text-sm font-bold transition-all hover:shadow-md disabled:opacity-50"
                style={{ background: 'linear-gradient(135deg, #1E3A8A, #3B82F6)' }}>
                {saving ? 'Menyimpan...' : 'Simpan'}
              </button>
            </div>
          </div>
        </div>
      )}

      {/* ── Modal Dari Regulasi ─────────────────────────────────────── */}
      {modal === 'regulasi' && (
        <div className="fixed inset-0 z-50 flex items-center justify-center p-4"
          style={{ background: 'rgba(15,23,42,0.7)', backdropFilter: 'blur(4px)' }}
          onClick={e => e.target === e.currentTarget && setModal(null)}>
          <div className="bg-white rounded-2xl shadow-2xl w-full max-w-xl flex flex-col"
            style={{ height: '85vh' }}>

            {/* Header modal */}
            <div className="flex items-center justify-between p-5 border-b border-slate-100 flex-shrink-0">
              <div>
                <div className="flex items-center gap-2">
                  <Sparkles size={18} className="text-blue-600" />
                  <h3 className="font-bold text-slate-800 text-lg" style={{ fontFamily: "'Outfit', sans-serif" }}>
                    Tambah dari Regulasi
                  </h3>
                </div>
                <p className="text-xs text-slate-500 mt-0.5">Permendikdasmen No. 13 Tahun 2025</p>
              </div>
              <button onClick={() => setModal(null)} className="p-1.5 rounded-lg hover:bg-slate-100 text-slate-400">
                <X size={18} />
              </button>
            </div>

            {/* Pilih jenjang & kelas */}
            <div className="p-5 border-b border-slate-100 flex-shrink-0">
              <div className="grid grid-cols-2 gap-3">
                <div>
                  <label className="text-xs font-bold text-slate-600 block mb-1.5">Jenjang</label>
                  <div className="flex gap-2 flex-wrap">
                    {JENJANG_LIST.map(j => (
                      <button key={j} onClick={() => { setRegJenjang(j); setRegKelas(JENJANG_KELAS[j][0]); setRegSelected(new Set()); setRegExpanded({}); }}
                        className={`px-3 py-1.5 rounded-lg text-xs font-bold transition-all ${
                          regJenjang === j ? 'text-white shadow-sm' : 'bg-slate-100 text-slate-500 hover:bg-slate-200'
                        }`}
                        style={regJenjang === j ? { background: 'linear-gradient(135deg, #1E3A8A, #3B82F6)' } : {}}>
                        {j}
                      </button>
                    ))}
                  </div>
                </div>
                <div>
                  <label className="text-xs font-bold text-slate-600 block mb-1.5">Kelas</label>
                  <div className="flex gap-2 flex-wrap">
                    {JENJANG_KELAS[regJenjang].map(k => (
                      <button key={k} onClick={() => { setRegKelas(k); setRegSelected(new Set()); setRegExpanded({}); }}
                        className={`px-3 py-1.5 rounded-lg text-xs font-bold transition-all ${
                          regKelas === k ? 'text-white shadow-sm' : 'bg-slate-100 text-slate-500 hover:bg-slate-200'
                        }`}
                        style={regKelas === k ? { background: 'linear-gradient(135deg, #1E3A8A, #3B82F6)' } : {}}>
                        {k}
                      </button>
                    ))}
                  </div>
                </div>
              </div>
            </div>

            {/* Daftar mapel */}
            <div className="flex-1 min-h-0 overflow-y-auto">
            <div className="p-5 flex flex-col gap-3">
              {availableItems.length === 0 ? (
                <div className="text-center py-10 text-slate-400">
                  <BookOpen size={32} className="mx-auto mb-2 opacity-30" />
                  <div className="text-sm font-medium">Semua mata pelajaran regulasi</div>
                  <div className="text-xs mt-1">untuk {regJenjang} Kelas {regKelas} sudah ditambahkan.</div>
                </div>
              ) : (
                <>
                  {/* Select all bar */}
                  <div className="flex items-center justify-between py-2 px-3 bg-blue-50 rounded-xl border border-blue-100">
                    <span className="text-xs text-blue-700 font-semibold">
                      {regSelected.size} dari {availableItems.length} dipilih
                    </span>
                    <button onClick={regSelected.size === availableItems.length ? () => setRegSelected(new Set()) : selectAllAvailable}
                      className="text-xs text-blue-600 font-bold hover:text-blue-800 transition-colors">
                      {regSelected.size === availableItems.length ? 'Batalkan Semua' : 'Pilih Semua'}
                    </button>
                  </div>

                  {/* Grouped by kategori */}
                  {Object.entries(groupedAvailable).map(([kategori, items]) => {
                    const allCatSelected = items.every(i => regSelected.has(i.name));
                    const someCatSelected = items.some(i => regSelected.has(i.name));
                    const isExpanded = regExpanded[kategori] !== false; // default expanded

                    return (
                      <div key={kategori} className="border border-slate-200 rounded-xl overflow-hidden">
                        {/* Kategori header */}
                        <button
                          onClick={() => setRegExpanded(prev => ({ ...prev, [kategori]: !isExpanded }))}
                          className="w-full flex items-center justify-between px-4 py-2.5 bg-slate-50 hover:bg-slate-100 transition-colors">
                          <div className="flex items-center gap-2">
                            <button
                              onClick={e => { e.stopPropagation(); toggleKategori(kategori, items); }}
                              className="text-blue-500 hover:text-blue-700 flex-shrink-0">
                              {allCatSelected
                                ? <CheckSquare size={16} className="text-blue-600" />
                                : someCatSelected
                                  ? <CheckSquare size={16} className="text-blue-300" />
                                  : <Square size={16} className="text-slate-400" />}
                            </button>
                            <span className={`text-xs font-bold px-2 py-0.5 rounded-full ${KATEGORI_COLOR[kategori] || 'bg-slate-100 text-slate-600'}`}>
                              {kategori}
                            </span>
                            <span className="text-xs text-slate-400">{items.length} mapel</span>
                          </div>
                          {isExpanded ? <ChevronUp size={14} className="text-slate-400" /> : <ChevronDown size={14} className="text-slate-400" />}
                        </button>

                        {/* Items dalam kategori */}
                        {isExpanded && (
                          <div className="divide-y divide-slate-100">
                            {items.map(item => {
                              const checked = regSelected.has(item.name);
                              return (
                                <label key={item.name}
                                  className={`flex items-center gap-3 px-4 py-2.5 cursor-pointer transition-colors ${
                                    checked ? 'bg-blue-50' : 'hover:bg-slate-50'
                                  }`}>
                                  <input type="checkbox" checked={checked}
                                    onChange={() => toggleRegItem(item.name)}
                                    className="rounded text-blue-600 flex-shrink-0" />
                                  <div className="flex-1 min-w-0">
                                    <span className="text-sm text-slate-700 font-medium">{item.name}</span>
                                    {!item.wajib && (
                                      <span className="ml-1.5 text-[10px] text-orange-500 font-semibold">Pilihan</span>
                                    )}
                                  </div>
                                </label>
                              );
                            })}
                          </div>
                        )}
                      </div>
                    );
                  })}
                </>
              )}
            </div>
            </div>

            {/* Footer modal */}
            <div className="p-5 border-t border-slate-100 flex-shrink-0 flex gap-3">
              <button onClick={() => setModal(null)}
                className="flex-1 py-2.5 rounded-xl border border-slate-200 text-slate-600 text-sm font-semibold hover:bg-slate-50 transition-colors">
                Batal
              </button>
              <button
                onClick={handleSaveFromRegulasiModal}
                disabled={regSaving || regSelected.size === 0 || availableItems.length === 0}
                className="flex-2 min-w-0 flex-1 py-2.5 rounded-xl text-white text-sm font-bold transition-all hover:shadow-md disabled:opacity-40 disabled:cursor-not-allowed"
                style={{ background: 'linear-gradient(135deg, #1E3A8A, #3B82F6)' }}>
                {regSaving
                  ? 'Menambahkan...'
                  : regSelected.size > 0
                    ? `Tambah ${regSelected.size} Mapel`
                    : 'Pilih Mapel'}
              </button>
            </div>
          </div>
        </div>
      )}
    </DashboardLayout>
  );
};
